import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { Popover } from '@shopify/polaris'
import styled, { css } from 'styled-components'
import interact from 'interact.js'
import get from 'lodash/get'
import clone from 'lodash/clone'

import ShowcaseLink from 'templates/outSide/components/showcase/ShowcaseLink'
import PopupMenu from '../../shopifyOverlay/PopupMenu'

const backgroundCss = css`
  background-color: rgba(56, 153, 236, 0.2);
  border: solid 1px #000edd;
`

const LinkContainer = styled.div`
  & > div > .ou_showcase__link {
    ${props => props.editable ? backgroundCss : ''}
    cursor: ${props => props.isMove ? 'move' : 'default'};
    opacity: ${props => props.noneProduct ? 0.5 : 1};


    & > span {
      color: #FFF;
    }
  }
`

export default class ProductLink extends Component {

  constructor (props) {
    super(props)
    this.state = {
      menuVisible: true,
      currentX: get(props.product, 'offsetX', 0),
      currentY: get(props.product, 'offsetY', 0),
    }
  }

  componentDidMount () {
    document.getElementsByTagName('body')[0].addEventListener('click', this.handlePageClick)
    this.htmlElement = document.querySelector('html')
  }

  componentWillReceiveProps (nextProps) {
    const { idx, productIdx, isMoveMode } = this.props
    const newCurrentX = get(nextProps.product, 'offsetX', 0)
    const newCurrentY = get(nextProps.product, 'offsetY', 0)
    if (newCurrentX !== this.state.currentX || newCurrentY !== this.state.currentY) {
      this.setState({
        currentX: newCurrentX,
        currentY: newCurrentY
      })
    }
    if (idx === productIdx && nextProps.isMoveMode !== isMoveMode) {
      // console.log('move mode enabled', nextProps.isMoveMode, idx)
      this.initMoveControls(nextProps.isMoveMode)
    }
  }

  initMoveControls = (isEnabled) => {
    const elementRef = this.overlayRef
    // console.log('initMoveResizeControls', elementRef, isEnabled)
    if (elementRef) {
      let draggable = { enabled: false }
      if (isEnabled) { // Dragging is allowed for this element
        draggable = {
          onstart: this.onDragStart,
          onmove: this.onDragMove,
          onend: this.onDragEnd,
        }
      }
      interact(elementRef).draggable(draggable)
    }
  }

  onDragStart = () => {
    // console.log('onDragStart')
    this.rem = parseFloat(this.htmlElement.style.fontSize)
    this.setState({
      menuVisible: false
    })
  }

  onDragMove = (e) => {
    this.setState({
      currentX: this.state.currentX + e.dx / this.rem,
      currentY: this.state.currentY + e.dy / this.rem,
    })
  }

  onDragEnd = () => {
    this.setState({menuVisible: true})
    const { productIdx, updateProduct, product } = this.props
    const { currentX, currentY } = this.state
    const productCopy = clone(product)
    productCopy.offsetX = currentX
    productCopy.offsetY = currentY
    updateProduct(productIdx, productCopy)
  }

  onShowcaseLinkMounted = (ref) => {
    if (ref) this.overlayRef = ref
  }

  showProduct = (productId) => {
    // console.log('show product', productId)
  }

  renderLinkContent = () => {
    const { showcase, product, idx } = this.props
    const { currentX, currentY } = this.state
    const style = {
      marginTop: `${currentY}rem`,
      marginLeft: `${currentX}rem`
    }
    let productTitle = 'Choose product'
    if (product.productId !== '' && product.title) productTitle = product.title
    // console.log('style', style)
    return (
      <ShowcaseLink
        key={idx}
        productId={idx}
        content={productTitle}
        x={product.x}
        y={product.y}
        // onLinkClick={() => this.showProduct(product.id)}
        idx={idx}
        slideId={showcase.slideId}
        style={style}
      />
    )
  }


  onEditButtonClick = (idx) => {
    return (i) => () => {
      // console.log('onEditButtonClick', idx, i)
      const { changeProductIdx } = this.props
      changeProductIdx(idx)
    }
  }

  onMenuButtonClick = (idx) => {
    return (i) => () => {
      // console.log('onMenuButtonClick', idx, i)
      const { enableLinkMoveMode } = this.props
      enableLinkMoveMode(i === 1)
    }
  }

  renderPopupMenu () {
    const { productIdx, isMoveMode, idx } = this.props
    if (idx === productIdx) {
      return (
        <PopupMenu
          buttons={[
            { title: 'Select Product' },
            { title: 'Move link' },
          ]}
          activeButtonIndex={isMoveMode ? 1 : 0}
          onButtonClick={this.onMenuButtonClick(idx)}
        />
      )
    } else {
      return (
        <PopupMenu
          buttons={[ { title: 'Edit' } ]}
          activeButtonIndex={1}
          onButtonClick={this.onEditButtonClick(idx)}
        />
      )
    }
  }


  render () {
    const { idx, popoverActive, productIdx, isMoveMode, product, productLinksEditable } = this.props
    const { menuVisible } = this.state
    return (
      <LinkContainer
        innerRef={this.onShowcaseLinkMounted}
        key={idx}
        isMove={idx === productIdx && isMoveMode}
        noneProduct={product.productId === ''}
        editable={productLinksEditable}
      >
        <Popover
          active={popoverActive && menuVisible && productLinksEditable}
          activator={this.renderLinkContent()}
          preferredPosition='above'
          onClose={() => null}
        >
          {this.renderPopupMenu()}
        </Popover>
      </LinkContainer>
    )
  }
}

ProductLink.propTypes = {
  product: PropTypes.object.isRequired,
  idx: PropTypes.number.isRequired,
  showcase: PropTypes.object.isRequired,
  changeProductIdx: PropTypes.func.isRequired,
  enableLinkMoveMode: PropTypes.func.isRequired,
  isMoveMode: PropTypes.bool.isRequired,
  productIdx: PropTypes.number.isRequired, // current active product index
  popoverActive: PropTypes.bool.isRequired,
  updateProduct: PropTypes.func.isRequired,
  productLinksEditable: PropTypes.bool.isRequired
}



// WEBPACK FOOTER //
// ./src/components/shopifyApp/shopifyWizard/productsSlideWizard/phoneContent/ProductLink.js